import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from 'react-icons/md';
import { PageSizeSelect } from './PageSizeSelect';

interface FileListPaginationProps {
  handlePreviousPage: () => void;
  handleNextPage: () => void;
  canPreviousPage: boolean;
  canNextPage: boolean;
  pageNb: number;
  pageSize: number;
  totalFiles: number;
}

export const FileListPagination = ({
  handlePreviousPage,
  handleNextPage,
  canPreviousPage,
  canNextPage,
  pageNb,
  pageSize,
  totalFiles,
}: FileListPaginationProps) => {
  return (
    <div className="mt-2 flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-2">
          <button
            onClick={handlePreviousPage}
            className="rounded-full p-2 hover:bg-gray-100 disabled:opacity-50 dark:hover:bg-gray-800"
            disabled={!canPreviousPage}
          >
            <MdOutlineKeyboardArrowLeft className="text-2xl" />
          </button>
          <button
            onClick={handleNextPage}
            className="rounded-full p-2 hover:bg-gray-100 disabled:opacity-50 dark:hover:bg-gray-800"
            disabled={!canNextPage}
          >
            <MdOutlineKeyboardArrowRight className="text-2xl" />
          </button>
        </div>
        <PageSizeSelect currentPageSize={pageSize} />
      </div>
      <span className="text-sm text-gray-500 dark:text-gray-400">
        {`${(pageNb - 1) * pageSize + 1}-${Math.min(
          pageNb * pageSize,
          totalFiles
        )} sur ${totalFiles}`}
      </span>
    </div>
  );
};
